module.exports = __webpack_public_path__ + "static/media/bodiometer_workflow_landscape.59b91621.mp4";